
import {
  defineComponent,
  ref,
  shallowRef,
  onMounted,
  computed,
  watch,
  nextTick,
} from "vue";
import ActivityModal from "@/views/user/modal/ActivityModal.vue";
import { FormApi } from "@/services/api/Form.service";
import { IForm } from "@/interfaces/iForm";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import VZSideDrawer from "@/components/content/VZSideDrawer.vue";
import { FormatMethods, getMaxLengthErrorMessage } from "@/helpers/data-format";
import { usePagination } from "@/helpers/pagination";
import FormDetail from "@/views/form/views/FormDetail.vue";
import FormDatamodel from "@/views/form/views/FormDatamodel.vue";
import { ITabConfig } from "@/interfaces/iTabConfig";
import { IBulkDelete } from "@/interfaces/iPageModel";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { TranslationService } from "@/core/services/TranslationService";
import { IAddEditFormModel } from "@/interfaces/iAddEditFormModel";
import { DrawerComponent } from "@/assets/ts/components";
import VZDeleteModal from "@/components/content/VZDeleteModal.vue";
import KTCreateFormModal from "@/components/modals/wizards/CreateFormModal.vue";
import * as Yup from "yup";
import { useToast } from "vue-toastification";
import {
  formTableBulkDelete,
  formTableFilters,
  formTableHeaders,
  FORM_TABS,
} from "./dataTableOptions";
import FormCloneModal from "@/components/modals/forms/FormCloneModal.vue";
import { hasPermission } from "@/core/services/permission.service";
import { Modal } from "bootstrap";
import { getLookups } from "@/services/api/Lookup.service";
export default defineComponent({
  name: "form-index",
  // eslint-disable-next-line vue/no-unused-components
  components: {
    Datatable,
    VZSideDrawer,
    // eslint-disable-next-line vue/no-unused-components
    FormDetail,
    // eslint-disable-next-line vue/no-unused-components
    FormDatamodel,
    VZDeleteModal,
    KTCreateFormModal,
    ActivityModal,
    "vz-form-clone-modal": FormCloneModal,
  },
  setup() {
    const t = (key: string) => {
      return TranslationService.translate(key);
    };
    const toast = useToast();
    const addMessage = t("pages.form.formAddedMessage");
    const editMessage = t("pages.form.formUpdatedMessage");
    const cannotCloneMsg = t("pages.form.cannotClone");
    const showDeleteDialog = ref<any>(false);
    const { page, total, rowsPerPage } = usePagination();
    const loading = ref(false);
    const defaultFilter = ref({ status: "ACTIVE" });
    const showSearch = true;
    const sideDrawerTitle = ref<string>("");
    const sideDrawerIcon = ref<string>("");
    const openDrawer = ref<boolean>(false);
    const openCloneModal = ref<boolean>(false);
    const formWebId = ref<any>();
    const tableData = ref<IForm[]>([]);
    const selectedForAction = ref<Partial<IForm>>({});
    const bulkDelete = ref<IBulkDelete>(formTableBulkDelete());
    const tableHeader = ref(formTableHeaders());
    const tableFilter = ref(formTableFilters());
    let formObj = ref<any>({});

    const tabs = shallowRef<ITabConfig[]>(FORM_TABS());
    let permissionModel = ref<any>({
      create: "VYZOR:TEMPLATES:FORMS:CREATE",
      delete: "VYZOR:TEMPLATES:FORMS:DELETE",
      update: "VYZOR:TEMPLATES:FORMS:UPDATE",
    });
    const singleForm = ref({
      webId: 1,
      startDate: "",
      endDate: "",
      name: "",
      frequency: "",
      locationRestrict: false,
      status: "Active",
      sequence: false,
      myFormSectionGlobalModel: ref<Array<any>>([]),
      formCategoryGlobalModel: {
        categoryCode: ref<Array<number>>([]),
      },
      formSectionGlobalModel: {
        sectionIds: ref<Array<number>>([]),
      },
      formSiteGlobalModel: {
        siteIds: ref<Array<number>>([]),
      },
      formEventGlobalModel: {
        eventIds: ref<Array<number>>([]),
      },
      formUserGlobalModel: {
        userIds: ref<Array<number>>([]),
      },
      formRoleGlobalModel: {
        roleIds: ref<Array<number>>([]),
      },
    });
    let formData = ref<IAddEditFormModel>({
      page: "form",
      header: "Form",
      edit: false,
      data: null,
      label: [
        { addHeader: t("pages.form.addForm") },
        { editHeader: t("pages.form.editForm") },
      ],
      validationSchema: Yup.object({
        name: Yup.string()
          .max(30, getMaxLengthErrorMessage(t("pages.form.formName"), 30))
          .matches(
            /^[a-zA-Z]+/,
            t("pages.form.formName") + " " + t("textValidation")
          )
          .required(t("pages.form.formName") + " " + t("common.isRequired")),
        startDate: Yup.date().required(
          t("common.startDate") + " " + t("common.isRequired")
        ),
      }),
      model: [
        {
          name: "name",
          label: t("pages.form.formName"),
          type: "text",
          required: true,
          showOnlyInEdit: false,
          disabled: false,
        },
        {
          name: "startDate",
          label: t("common.startDate"),
          type: "date",
          required: true,
          format: "DD-MM-YYYY",
          showOnlyInEdit: false,
          disabled: false,
        },
        // {
        //   name: "frequency",
        //   label: t("pages.form.documentFrequency"),
        //   type: "radio",
        //   value: "Document Frequency",
        //   required: true,
        //   showOnlyInEdit: false,
        //   disabled: false,
        // },
        // {
        //   name: "frequency",
        //   label: t("pages.form.sectionFrequency"),
        //   type: "radio",
        //   value: "Section Frequency",
        //   required: true,
        //   showOnlyInEdit: false,
        //   disabled: false,
        // },
        {
          name: "locationRestrict",
          label: t("pages.form.locationRestriction"),
          type: "checkbox",
          required: true,
          showOnlyInEdit: false,
          disabled: false,
        },
        {
          name: "probePic",
          label: t("pages.form.probePic"),
          type: "checkbox",
          required: true,
          showOnlyInEdit: false,
          disabled: false,
        },
      ],
    });
    const resetWebId = (id) => {
      if (formWebId.value === undefined || formWebId.value === id) {
        formWebId.value = id;
      } else if (formWebId.value !== undefined) {
        let existingElement = document.querySelector(
          ".show-form-" + formWebId.value
        );
        if (existingElement) {
          existingElement.classList.remove("show");
        }
        formWebId.value = id;
      }
    };

    const localPreference = ref({});
    const format = computed(() => {
      return FormatMethods;
    });
    const tableRowClick = (item) => {
      openDrawer.value = true;
      tabs.value = tabs.value.map((tab) => {
        return {
          ...tab,
          props: { ...tab.props, data: item, openDrawer: openDrawer },
        };
      });
      sideDrawerTitle.value = item.name;
      sideDrawerIcon.value = "bi bi-layers fs-2x";
      DrawerComponent?.getInstance("vz__drawer")?.toggle();
    };
    onMounted(async () => {
      setCurrentPageBreadcrumbs(t("pages.form.title"), ["Home", "Forms"]);
      expandMenu();
      loading.value = true;
      // queryUpdate({
      //   ...defaultFilter.value,
      //   page: page.value - 1,
      //   size: rowsPerPage.value,
      // });
      var drawerElement = document.getElementById("vz__drawer");
      drawerElement?.addEventListener("transitionend", function (event) {
        if (event?.propertyName === "transform") {
          const targetElement = event.target as HTMLElement;
          if (targetElement.className === "drawer drawer-end") {
            // loadData();
            openDrawer.value = false;
          }
        }
      });
    });
    const queryUpdate = async (params?: any) => {
      try {
        loading.value = true;
        if (!params || !params.sort) {
          params = {
            ...params,
            sort: "createdDate,desc",
            startDate: params?.startDate === null ? [] : params?.startDate,
          };
        }
        localPreference.value = { ...params };
        const data = await FormApi.getInstance().getFormList({
          ...params,
        });
        tableData.value = [...data.content];
        total.value = data.totalElements;
        rowsPerPage.value = data.size;
        page.value = ++data.number;
      } catch (err) {
        console.error(err);
      } finally {
        loading.value = false;
      }
    };

    const deleteForm = (item: IForm) => {
      console.log(item);
    };
    const getFormSites = async (webId) => {
      try {
        return await getLookups("site/siteForms/" + webId + "/sites");
      } catch (err) {
        console.log(err);
      }
    };
    const setFormCloneData = async (data: IForm, check) => {
      try {
        const sitesList: any = await getFormSites(data.webId);
        if (sitesList.content.length === 0) {
          toast.error(cannotCloneMsg);
          return;
        }
      } catch (error) {
        console.error(error);
      }
      let existingElement = document.querySelector(".show-form-" + data.webId);
      if (existingElement) {
        existingElement.classList.remove("show");
      }
      formWebId.value = data.webId;
      formObj.value = data;
      openCloneModal.value = true;
      await nextTick();
      const modal = new Modal(
        document.getElementById(`kt_form_clone`) as HTMLElement
      );
      modal.show();
    };
    const createForm = () => {
      singleForm.value = {
        webId: 1,
        startDate: "",
        endDate: "",
        name: "",
        frequency: "",
        locationRestrict: false,
        status: "Active",
        sequence: false,
        myFormSectionGlobalModel: [],
        formCategoryGlobalModel: {
          categoryCode: [],
        },
        formSectionGlobalModel: {
          sectionIds: [],
        },
        formSiteGlobalModel: {
          siteIds: [],
        },
        formEventGlobalModel: {
          eventIds: [],
        },
        formUserGlobalModel: {
          userIds: [],
        },
        formRoleGlobalModel: {
          roleIds: [],
        },
      };
    };

    const loadData = async () => {
      await queryUpdate({ ...localPreference.value });
      const matchingObject = tableData.value.findIndex(
        (obj) => obj.webId === singleForm.value.webId
      );
      if (matchingObject > -1) {
        await createForm();
        // editForm(tableData.value[matchingObject]);
      }
    };

    const editForm = (item) => {
      let existingElement = document.querySelector(
        ".clone-form.show-form-" + formWebId.value
      );
      if (existingElement) {
        existingElement.classList.remove("show");
      }
      singleForm.value.webId = item.webId;
      singleForm.value.name = item.name;
      singleForm.value.startDate = item.startDate;
      singleForm.value.endDate = item.endDate;
      singleForm.value.frequency = item.frequency;
      singleForm.value.locationRestrict = item.locationRestrict;
      singleForm.value.sequence = item.sequence;
      singleForm.value.status = item.status;
      if (item.formCategoryModels) {
        item.formCategoryModels.forEach((value, index) => {
          singleForm.value.formCategoryGlobalModel.categoryCode.push(
            value.categoryCode
          );
        });
      }
      if (item.formDefinitionSectionModels) {
        item.formDefinitionSectionModels.forEach((value, index) => {
          singleForm.value.formSectionGlobalModel.sectionIds.push(
            value.formSectionId
          );
          let uniqueSectionIds = Array.from(
            new Set(singleForm.value.formSectionGlobalModel.sectionIds)
          ) as number[];
          singleForm.value.formSectionGlobalModel.sectionIds = uniqueSectionIds;
          singleForm.value.myFormSectionGlobalModel.push(value);
        });
      }
      if (item.formUserModel) {
        item.formUserModel.forEach((value, index) => {
          singleForm.value.formUserGlobalModel.userIds.push(
            value.siteId.toString() + value.userId.toString()
          );
        });
      }
      if (item.formRoleModel) {
        item.formRoleModel.forEach((value, index) => {
          singleForm.value.formRoleGlobalModel.roleIds.push(
            value.siteId.toString() + value.roleId.toString()
          );
        });
      }
    };

    const submit = async (reqData) => {
      loading.value = true;
      reqData = formData.value.edit ? reqData : { ...reqData };
      let message = formData.value.edit ? editMessage : addMessage;
      await FormApi.getInstance()
        .addForm(reqData, formData.value.edit)
        .then(() => {
          toast.success(message);
          queryUpdate({
            ...defaultFilter.value,
            page: page.value - 1,
            size: rowsPerPage.value,
          });
        })
        .catch(() => {
          //
        })
        .finally(() => {
          loading.value = false;
        });
    };
    const refreshList = () => {
      showDeleteDialog.value = false;
      createForm();
      queryUpdate({ ...localPreference.value });
    };
    watch(
      showDeleteDialog,
      (showDeleteDialog) => {
        if (showDeleteDialog) {
          let existingElement = document.querySelector(
            ".clone-form.show-form-" + formWebId.value
          );
          if (existingElement) {
            existingElement.classList.remove("show");
          }
        }
      },
      { deep: true }
    );
    const expandMenu = () => {
      let menuItems = document.querySelectorAll(".side-menu-class");
      menuItems[3].className =
        "menu-link accordion-button border-0 bg-transparent py-4 shadow-none text-hover-white side-menu-class";
      let childItems = document.querySelectorAll(
        ".site-menu-item-class, .collapse"
      );
      childItems.forEach((element) => {
        if (element.id == "menu-section-3") {
          element.className =
            "accordion-collapse menu-item site-menu-item-class collapse show";
        }
      });
    };
    const deleteAlertMessage = (item: any) => {
      if (item.createdByScheduler) {
        return `${t("validation.createdByScheduler")} ${item.name}?`;
      }

      return `${t("validation.sureToDelete")} ${item.name}?`;
    };
    const someOfSelectedForms = t("bulkDelete.someOfSelectedForms");
    const areYouSure = t("bulkDelete.areYouSureForms");
    const bulkDeleteTextForForms = ref<string | null>(null);
    const selectedItemsForDelete = (items: any) => {
      if (items.length) {
        const selectedForms = tableData.value.filter((form) =>
          items.includes(form.webId)
        );
        const attachedForms = selectedForms.filter(
          (form: any) => form.createdByScheduler
        );
        const areFormsAttached = attachedForms.length > 0;
        if (areFormsAttached) {
          bulkDeleteTextForForms.value = `${someOfSelectedForms}${areYouSure}`;
        } else {
          bulkDeleteTextForForms.value = null;
        }
      } else {
        bulkDeleteTextForForms.value = null;
      }
    };
    return {
      bulkDelete,
      format,
      formData,
      tabs,
      tableData,
      tableHeader,
      tableFilter,
      sideDrawerTitle,
      sideDrawerIcon,
      showSearch,
      openDrawer,
      page,
      total,
      rowsPerPage,
      defaultFilter,
      loading,
      selectedForAction,
      deleteForm,
      editForm,
      tableRowClick,
      queryUpdate,
      submit,
      t,
      refreshList,
      permissionModel,
      hasPermission,
      singleForm,
      createForm,
      formObj,
      setFormCloneData,
      expandMenu,
      showDeleteDialog,
      loadData,
      resetWebId,
      openCloneModal,
      deleteAlertMessage,
      bulkDeleteTextForForms,
      selectedItemsForDelete,
      getFormSites,
    };
  },
});
